<template>
    <div class="m-2">
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Активен</span>
            <span class="w-2/3">
                <CBadge :color="entity.enabled ? 'success' : 'secondary'">
                    {{ entity.enabled ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Место показа</span>
            <span class="w-2/3">{{ routeNamesMap[entity.route_name] }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Позиция показа</span>
            <span class="w-2/3">{{ entity.place }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Код AppsFlyer</span>
            <span class="w-2/3">{{ entity.code }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Название акции</span>
            <span class="w-2/3">{{ entity.title }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">{{ routeNamesMap[entity.route_name] }}</span>
            <span class="w-2/3" v-html="entities"></span>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');

    export default {
        props: {
            entity: {
                type: Object,
                default: () => {},
            },
        },

        data: () => ({
            routeNamesVar: {
                'restaurant-list': 'restaurants',
                'grocery-list': 'grocers',
                'pharmacy-list': 'pharmacies',
            },
            routeNamesMap: {
                'restaurant-list': 'Список ресторанов',
                'grocery-list': 'Список продуктовых магазинов',
                'pharmacy-list': 'Список аптек',
            },
            restaurants: [],
            grocers: [],
            pharmacies: [],
            assistants: [],
        }),

        computed: {
            entities() {
                return this[this.routeNamesVar[this.entity.route_name]] ? this[this.routeNamesVar[this.entity.route_name]].filter(el => {
                    return this.entity.list.includes(el.id);
                }).map(el => {
                    return el.title
                }).join('<br>') : '';
            },
        },

        async created() {
            const { data: restaurants } = await Vue.axios.get('/restaurants');
            this.restaurants = restaurants;
            const { data: grocers } = await Vue.axios.get('/grocers');
            this.grocers = grocers;
            const { data: pharmacies } = await Vue.axios.get('/pharmacies');
            this.pharmacies = pharmacies;
        },

        methods: {
            formatDate(date) {
                return formatDate(date);
            },
            pictureUrl(picture) {
                return picture ? (process.env.VUE_APP_STATIC_BASE_URL + '/' + picture) : '';
            },
        },
    };
</script>
